import axios from 'axios';
import config from '../config';

const getGeneralContent = async() => {
  const applicationId = config.APPLICATION_ID;

  try {
    const response = await axios.get(
      `${config.API_BASE_URL}/content`,
      {
        headers: {
          'X-Application-Id': applicationId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export {getGeneralContent};